document.addEventListener("DOMContentLoaded", function() {
  var lazyImages = [].slice.call(document.querySelectorAll("img.merox-lazy"));

  if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
    let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          lazyImage.classList.remove("merox-lazy");
          lazyImageObserver.unobserve(lazyImage);

          // Load the next image in the gallery
          let nextImage = lazyImage.closest('.swiper-slide').nextElementSibling?.querySelector('img.merox-lazy');
          if (nextImage) {
            nextImage.src = nextImage.dataset.src;
            nextImage.classList.remove("merox-lazy");
            lazyImageObserver.unobserve(nextImage); // Optional: if you want to stop observing the next image after loading
          }
        }
      });
    });

    lazyImages.forEach(function(lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  var galleries = document.querySelectorAll('.m_grid_gallery');
  galleries.forEach(function(gallery) {
    var dots = gallery.querySelector('.swiper-pagination');
    new Swiper(gallery, {
      loop: false,
      slidesPerView: 1,
      pagination: {
        el: dots,
        clickable: true,
      },
    });
  });
});


// COLLECTION LAYOUT SWITCHER
function setLocalStorage(key, value) {
  localStorage.setItem(key, value);
}

function getLocalStorage(key) {
  return localStorage.getItem(key);
}

function initializeLayoutState() {
  const layout = getLocalStorage('layout');
  if (layout == 'single') {
    $('.m-collection-product-list').addClass('m_singleProductLayout');
    $('.singleLayout').addClass('activeLayout');
    $('.defaultLayout').removeClass('activeLayout');
  } else {
    $('.m-collection-product-list').removeClass('m_singleProductLayout');
    $('.defaultLayout').addClass('activeLayout');
    $('.singleLayout').removeClass('activeLayout');
  }
}

$('body').on('click', '.singleLayout', function() {
  $('.m-collection-product-list').addClass('m_singleProductLayout');
  $('.singleLayout').addClass('activeLayout');
  $('.defaultLayout').removeClass('activeLayout');
  setLocalStorage('layout', 'single');
});

$('body').on('click', '.defaultLayout', function() {
  $('.m-collection-product-list').removeClass('m_singleProductLayout');
  $('.defaultLayout').addClass('activeLayout');
  $('.singleLayout').removeClass('activeLayout');
  setLocalStorage('layout', 'default');
});
// END COLLECTION LAYOUT SWITCHER



var templateType = document.querySelector('body').getAttribute('data-template-type');
if (templateType == 'collection') {
  let previousUrl = window.location.href;
  let swiperInstances = [];

  const observer = new MutationObserver(function(mutations) {
    if (window.location.href !== previousUrl) {
      console.log('URL changed');
      previousUrl = window.location.href;
      
      swiperInstances.forEach(instance => instance.destroy(true, true));
      swiperInstances = [];

      var galleries = document.querySelectorAll('.m_grid_gallery');
      galleries.forEach(function(gallery) {
        var dots = gallery.querySelector('.swiper-pagination');
        new Swiper(gallery, {
          loop: false,
          slidesPerView: 1,
          pagination: {
            el: dots,
            clickable: true,
          },
        });
      });

      initializeLayoutState();

      var lazyImages = [].slice.call(document.querySelectorAll("img.merox-lazy"));
    
      if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
        let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              let lazyImage = entry.target;
              lazyImage.src = lazyImage.dataset.src;
              lazyImage.classList.remove("merox-lazy");
              lazyImageObserver.unobserve(lazyImage);
    
              // Load the next image in the gallery
              let nextImage = lazyImage.closest('.swiper-slide').nextElementSibling?.querySelector('img.merox-lazy');
              if (nextImage) {
                nextImage.src = nextImage.dataset.src;
                nextImage.classList.remove("merox-lazy");
                lazyImageObserver.unobserve(nextImage); // Optional: if you want to stop observing the next image after loading
              }
            }
          });
        });
    
        lazyImages.forEach(function(lazyImage) {
          lazyImageObserver.observe(lazyImage);
        });
      }

    }
  });
  const config = { subtree: true, childList: true };
  observer.observe(document, config);
}


$(document).ready(function() {
  initializeLayoutState();

  $('body').on('click', '.m_swatch', function(e) {
    e.preventDefault();
    console.log('clicked');
    
    var $this = $(this);
    var $parentVariant = $this.parents('.m_metafields_variants');
    var $productCard = $this.closest('.product-card');

    $parentVariant.find('.m_swatch a').removeClass('is-selected');
    $this.find('a').addClass('is-selected');

    var title = $this.data('title');
    var price = $this.data('price');
    var handle = '/products/' + $this.data('handle');
    var images = $this.data('images').split(',');
    var badges = $this.data('badges');
    var id = $this.data('id');

    $productCard.find('.product-card__title a').text(title);
    $productCard.find('.product-card__title a').attr('href', handle);
    $productCard.find('price-list').html(price);
    $productCard.find('.product-card__figure a').attr('href', handle);
    $productCard.find('.m_productBadges').html(badges);

    var galleryHTML = `
      <div class="swiper-container m_grid_gallery m_JSGallery m_JSGallery-${id}">
        <div class="swiper-wrapper"></div>
        <div class="swiper-pagination"></div>
      </div>`;
      
    $productCard.find('.m_defaultGallery, .m_JSGallery').remove();
    $productCard.find('.product-card__figure').append(galleryHTML);

    var $swiperWrapper = $productCard.find('.swiper-wrapper');
    images.forEach(function(image) {
      var slide = `
        <div class="swiper-slide">
          <a href="${handle}">
            <img src="${image}">
          </a>
        </div>`;
      $swiperWrapper.append(slide);
    });

    new Swiper('.m_JSGallery-' + id, {
      loop: false,
      slidesPerView: 1,
      pagination: {
        el: '.m_JSGallery-' + id + ' .swiper-pagination',
        clickable: true,
      },
    });
  });



    var $accButtons = $(".mx_mh_london_accordion_button");

  $('body').on("click", ".mx_mh_london_accordion_button", function(e) {
    e.preventDefault();
    var $button = $(this);
    var $content = $button.next(".mx_mh_london_accordion_content");
    var $arrow = $button.find(".arrow");

    if ($content.css("display") === "block") {
      $content.css("display", "none");
      $arrow.removeClass("rotate");
    } else {
      // Close all open accordion content
      $(".mx_mh_london_accordion_content").css("display", "none");
      // Reset all arrows
      $(".arrow").removeClass("rotate");

      $content.css("display", "block");
      $arrow.addClass("rotate");
    }
  });

  // Function to update the quantity input value
  function updateQuantity(input, increment) {
    let currentValue = parseInt(input.value);
    let max = input.getAttribute('max') ? parseInt(input.getAttribute('max')) : Infinity;
    let newValue = currentValue + increment;

    if (newValue >= 0 && newValue <= max) {
      input.value = newValue;

      $.ajax({
        type: 'POST',
        url: '/cart/change.js', 
        data: {
          id: input.dataset.lineKey,
          quantity: newValue
        },
        dataType: 'json',
        success: function(response) {
          console.log('Cart updated successfully', response);

          if($('body[data-template-type="cart"]').length > 0) {
            location.reload();
          }
          
          // document.dispatchEvent(new CustomEvent('line-item:change', {
          //   detail: {
          //     quantity: newValue,
          //     lineKey: input.dataset.lineKey 
          //   }
          // }));

          
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

          updateButtonStates(input, newValue, max);
          updateCartCount();
        },
        error: function(error) {
          console.error('Error updating cart', error);
        }
      });
      console.log(`Updated line ${input.dataset.lineKey} to quantity ${newValue}`);
    } else {
      console.log('Cannot update');
      updateButtonStates(input, newValue, max);
    }
  }

  // Function to update the state of the plus and minus buttons
  function updateButtonStates(input, value, max) {
    let $minusButton = $(input).closest('.m_quantityWrapper').find('.minusButton');
    let $plusButton = $(input).closest('.m_quantityWrapper').find('.plusButton');

    $minusButton.prop('disabled', value <= 0);
    $plusButton.prop('disabled', value >= max);
  }

  // Function to update the cart count bubble in the header
  function updateCartCount() {
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) {
        let itemCount = cart.item_count;
        $('.header__cart-count cart-count').text(itemCount);
      },
      error: function(error) {
        console.error('Error fetching cart data', error);
      }
    });
  }

  // Add event listeners for all plus buttons
  $('body').on('click', '.plusButton', function() {
    let input = $(this).closest('.m_quantityWrapper').find('.quantity-input')[0];
    updateQuantity(input, 1);
  });

  // Add event listeners for all minus buttons
  $('body').on('click', '.minusButton', function() {
    let input = $(this).closest('.m_quantityWrapper').find('.quantity-input')[0];
    updateQuantity(input, -1);
  });

  // Listen for the line-item:change event to perform any additional actions
  document.addEventListener('line-item:change', function(event) {
    let finalQuantity = event.detail.quantity; // New quantity (may be 0 !)
    let lineKey = event.detail.lineKey;
    console.log(`Line item ${lineKey} changed to quantity ${finalQuantity}`);

    // Additional logic if needed
  });

  // Initialize button states on page load
  $('.quantity-input').each(function() {
    let input = this;
    let max = input.getAttribute('max') ? parseInt(input.getAttribute('max')) : Infinity;
    let value = parseInt(input.value);
    updateButtonStates(input, value, max);
  });


  
});


